import React from "react";
import OppositionItem from "./OppositionItem";
import API from "../base/API";
import { browserHistory } from "react-router";
import { translate } from "../base/Translation";
import { getUser } from "../auth/Auth";

const headingStyle = {
    lineHeight: "30px",
    fontWeight: "400",
    fontSize: "2rem",
    marginBottom: "1rem",
    display: "block"
};

export default class OppositionList extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_oppositions: "/opposition/fetch/by/test/:testID",
            publish_oppositions: "/opposition/publish/:testID",
        });

        this.state = {
            items: []
        }
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reload !== this.props.reload) {
            this.reload();
        }
    }

    reload() {
        this.api.request({
            route: "get_oppositions",
            params: { "testID": this.props.test.id },
            success: (response) => {
                this.setState({ items: response });
            }
        })
    }

    onPublish(evt) {
        this.api.request({
            route: "publish_oppositions",
            params: { "testID": this.props.test.id },
            success: (response) => {
                alert(translate("Námietky boli odoslané. Stav testu sa zmenil na 'Kontrolovaný' ku ktorému nemáte prístup, preto budete presmerovaný na stránku testov."));
                browserHistory.push("/tests");
            }
        });
    }

    publishButton() {
        const drafts = this.state.items.filter((item) => {
            return item.status === "draft";
        });

        if (drafts.length === 0) {
            return false;
        }

        return (
            <div className="form-group">
                <button onClick={this.onPublish.bind(this)} className="btn btn-success">
                    <span className="fa fa-envelope" />&nbsp;{translate("Odoslať námietky")}
                </button>
            </div>
        )
    }

    renderList() {

        if (getUser().role !== 2) {
            return (
                <div>
                    <span style={headingStyle}>{translate("Námietky importéra")}</span>
                    {this.state.items.length > 0 ? this.state.items.filter(function (item) { return parseInt(item.user.role, 10) === 3 }).map((item, index) => {
                        return <OppositionItem data={item} list={this} key={index} />
                    }) : <span>{translate("Žiadne námietky neboli nájdené")}</span>}
                    <hr />
                    <span style={headingStyle}>{translate("Námietky prevádzky")}</span>
                    {this.state.items.length > 0 ? this.state.items.filter(function (item) { return parseInt(item.user.role, 10) === 2 }).map((item, index) => {
                        return <OppositionItem data={item} list={this} key={index} />
                    }) : <span>{translate("Žiadne námietky neboli nájdené")}</span>}
                </div>
            )
        } else {
            return (
                <div>
                    {this.state.items.length > 0 ? this.state.items.filter(function (item) { return parseInt(item.user.role, 10) === 2 }).map((item, index) => {
                        return <OppositionItem data={item} list={this} key={index} />
                    }) : <span>{translate("Žiadne námietky neboli nájdené")}</span>}
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.publishButton()}
                {this.renderList()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/opposition/OppositionList.jsx